import React from 'react';
import { FaGraduationCap, FaBook, FaUsers, FaArrowRight } from 'react-icons/fa';
import logo from '../images/logo.png';

const highlights = [
  { icon: FaGraduationCap, text: 'Expert instructors with industry experience' },
  { icon: FaBook, text: 'Comprehensive curriculum designed for success' },
  { icon: FaUsers, text: 'Supportive community of learners and educators' },
];

const stats = [
  { value: '200', suffix: '+', label: 'Students Enrolled' },
  { value: '5', suffix: '+', label: 'Expert Instructors' },
  { value: '6', suffix: '', label: 'Courses Offered' },
  { value: '95', suffix: '%', label: 'Success Rate' },
];

const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  if (section) window.scrollTo({ top: section.offsetTop - 80, behavior: 'smooth' });
};

const Home = () => {
  return (
    <div className="bg-surface-base text-ink-muted">
      {/* Hero */}
      <section className="relative overflow-hidden pt-32 pb-20 md:pt-40 md:pb-28">
        {/* One restrained glow, anchored behind the headline */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -top-40 left-1/2 h-[32rem] w-[52rem] -translate-x-1/2 rounded-full bg-brand-600/10 blur-3xl"
        />

        <div className="container-page relative">
          <div className="grid items-center gap-16 lg:grid-cols-[1.1fr_0.9fr]">
            <div className="reveal">
              <span className="eyebrow">Transforming Education</span>

              <h1 className="mt-5 text-4xl font-semibold leading-[1.1] text-ink md:text-5xl lg:text-6xl">
                Learn the skills that
                <br className="hidden sm:block" /> actually get you hired
              </h1>

              <p className="section-lead max-w-xl">
                AC Tech Institute runs practical, hands-on courses in technology, design and
                communication &mdash; taught in small groups in Beanibazar, Sylhet.
              </p>

              <div className="mt-9">
                <button onClick={() => scrollToSection('courses')} className="btn-primary">
                  Explore Courses
                  <FaArrowRight className="h-3 w-3" />
                </button>
              </div>

              <ul className="mt-12 space-y-4">
                {highlights.map(({ icon: Icon, text }) => (
                  <li key={text} className="flex items-center gap-3">
                    <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg border border-surface-line bg-surface-raised text-brand-400">
                      <Icon className="h-3.5 w-3.5" />
                    </span>
                    <span className="text-sm text-ink-muted">{text}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Brand panel */}
            <div className="reveal">
              <div className="card relative mx-auto max-w-sm p-8">
                <div className="flex flex-col items-center text-center">
                  <img src={logo} alt="AC Tech Institute" className="h-20 w-20 object-contain" />
                  <p className="mt-6 text-lg font-semibold text-ink">AC Tech Institute</p>
                  <p className="mt-1 text-xs uppercase tracking-[0.2em] text-ink-faint">
                    Since day one
                  </p>
                </div>

                <div className="rule my-7" />

                <div className="grid grid-cols-2 gap-6 text-center">
                  <div>
                    <p className="text-2xl font-semibold text-ink">200+</p>
                    <p className="mt-1 text-xs uppercase tracking-[0.14em] text-ink-faint">
                      Students
                    </p>
                  </div>
                  <div>
                    <p className="text-2xl font-semibold text-ink">95%</p>
                    <p className="mt-1 text-xs uppercase tracking-[0.14em] text-ink-faint">
                      Success
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="border-y border-surface-line bg-surface-sunken py-14">
        <div className="container-page">
          <dl className="grid grid-cols-2 gap-x-6 gap-y-10 lg:grid-cols-4">
            {stats.map(({ value, suffix, label }) => (
              <div key={label} className="text-center">
                <dt className="sr-only">{label}</dt>
                <dd>
                  <span className="block text-4xl font-semibold tracking-tight text-ink md:text-5xl">
                    {value}
                    <span className="text-brand-500">{suffix}</span>
                  </span>
                  <span className="mt-2 block text-xs font-medium uppercase tracking-[0.16em] text-ink-faint">
                    {label}
                  </span>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </section>
    </div>
  );
};

export default Home;
